import { useScriptClarity, useScriptGoogleTagManager, useScript, defineNuxtPlugin } from '#imports'

export default defineNuxtPlugin({
  name: "scripts:init",
  env: { islands: false },
  parallel: true,
  setup() {
    const googleTagManager = useScriptGoogleTagManager({"id":"G-QZCNB3NB2P"})
    const clarity = useScriptClarity({"id":"qr31cqy7cu"})
    return { provide: { $scripts: { googleTagManager, clarity } } }
  }
})